import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  width: 55%;
  padding: 60px;
  @media (max-width: ${props => props.theme.deviceWidth.mobilePhone}) {
    order: 2;
    width: 100%;
    padding: 10px;
  }

  > :first-child {
    margin-bottom: 10px;
  }

  > :not(:first-child) {
    margin-top: 10px;
  }

  > :not(:last-child):not(:first-child) {
    margin-bottom: 30px;
  }
`;
